export const lg = (content, extra = '', color?) => {
    console.log(
        `%cTERMINAL LOG%c ${content}`,
        `font-weight: bold; padding: 0 5px; color: black; background: ${
            color ? color : '#43A047'
        }; border-radius: 10px; `,
        'font-weight: bold; color: white;',
        extra,
    );
};
